import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlogComponent } from './blog.component';
import { BlogEntryComponent } from './blog-entry/blog-entry.component';
import { BlogCategoryComponent } from './blog-category/blog-category.component';
import { BlogTagComponent } from './blog-tag/blog-tag.component';

const routes: Routes = [
  { path: 'blog', component: BlogComponent },
  { path: 'blog/categories/:category', component: BlogCategoryComponent },
  { path: 'blog/tags/:tag', component: BlogTagComponent },
  { path: 'blog/entries/:id', component: BlogEntryComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class BlogRoutingModule {}
